const MAX_ATTEMPT_CLEAR_LOCALSTORAGE = 5;

function clearOldItems() {
  const keys = [];
  const entries = [];
  for (let i = 0; i < localStorage.length; i ++) {
    const key = localStorage.key(i);
    const entryMatch = key.match(/^clozev2\.(\S+)$/);
    if (!entryMatch || entryMatch[1] === 'hint') {
      continue;
    }
    entries.push([key, localStorage.getItem(key)])
  }
  entries.forEach((entry) => {
    try {
      const entity = JSON.parse(entry[1]);
      if (!entity.updated) {
        return;
      }
      keys.push({ key: entry[0], updated: entity.updated });
    } catch(e) {
      console.error(e);
    }
  });
  if (keys.length === 0) {
    return false;
  }
  keys.sort((a, b) => {
    if (a.updated < b.updated) {
      return -1;
    }
    if (a.updated > b.updated) {
      return 1;
    }
    return 0;
  });
  localStorage.removeItem(keys[0].key);
  return true;
}

export function setLocalStorageItem(key, value, alreadyCleared) {
  try {
    localStorage.setItem(key, value)
  } catch (e) {
    if((alreadyCleared || 0) < MAX_ATTEMPT_CLEAR_LOCALSTORAGE && e.name === 'QUOTA_EXCEEDED_ERR') {
      if (clearOldItems()) {
        setLocalStorageItem(key, value, (alreadyCleared || 0) + 1);
      } else {
        throw e;
      }
    } else {
      throw e;
    }
  }}
